import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './reducers/index'

const initialState = {}
const middleware = [thunk]
let store

if(process.env.REACT_APP_MODE == "development"){
    store = createStore(
        rootReducer, 
        initialState,
        compose(
            applyMiddleware(...middleware),
            window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
            )
        )
    }else{ 
        store = createStore(
            rootReducer, 
            initialState,
            compose(
                applyMiddleware(...middleware)
            )
        )
}


export default store


// WEBPACK FOOTER //
// ./src/store.js